import { useEffect } from 'react';

/**
 * Updates document <title>, meta description, canonical URL, and OG/Twitter
 * tags on every route change — no extra library needed.
 */
export function useSEO({ title, description, canonical, ogImage }) {
  useEffect(() => {
    // Title
    document.title = title;

    // Helpers
    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]',       'content', description);
    setMeta('link[rel="canonical"]',           'href',    canonical);

    // Open Graph
    setMeta('meta[property="og:title"]',       'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]',         'content', canonical);
    if (ogImage) setMeta('meta[property="og:image"]', 'content', ogImage);

    // Twitter
    setMeta('meta[name="twitter:title"]',       'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    if (ogImage) setMeta('meta[name="twitter:image"]', 'content', ogImage);
  }, [title, description, canonical, ogImage]);
}
